<script>
  export default {
    data() {
      return {
        selected: null,
      }
    },
  };
</script>
<template>
  <b-modal
    id="confirm-box"
    title=""
    size="lg"
    hide-header
    modal-class="modal-custom-container"
    ok-title="confirm">
    <header class="modal-header bd-bottom-blue pd-x-0-f">
      <h3 class="title-d20-bb">Confirm Action</h3>
    </header>
    <div class="modal-body-custom">
      <div class="main-form mg-t-0-f pd-0-f">
        <div class="form-group pt-3">
          <label class="label-control">Do you want to save data</label>
        </div>
      </div>
    </div>
  </b-modal>
</template>
